import { VoucherCategoryDetailPage } from '@/features/voucher-category/pages/VoucherCategoryDetailPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/voucher-category/$id/detail')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["voucher_category.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: VoucherCategoryDetailPage,
})
